const staggered_content = document.querySelectorAll('.block--staggered-fade-in-content');
staggered_content.forEach(block => {
    const items = block.querySelectorAll('.staggered-item');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-reveal')
                observer.unobserve(entry.target)
            }
        })
    }, {
        threshold: .1
    })

    items.forEach(item => observer.observe(item))
})




